import React, { useState } from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import { Helmet } from 'react-helmet'

// core components
import routes from "../routesJuego.js";
import OthelloCookieConsent from "../componentsothello/OthelloCookieConsent";
import PageLayout from "../components/LayoutContainers/PageLayout";

function LayoutJuego() {
    const [id_conexion, setidconexion] = useState("");
    const [loading, setLoading] = useState(true);

    const { search } = useLocation(); 

    React.useEffect(() => {

      /*  let url = search;
        let params = new URLSearchParams(url);
        let idconexion = "";

        if (params.has('ID'))
            idconexion = params.get('ID').split('-')[0];

        setidconexion(idconexion);*/
        setLoading(false);

    }, [loading]);


    const getRoutes = (allRoutes) => {
        return allRoutes.map((route) => {
            //si es un item collapse hacemos route de los hijos
            if (route.collapse)
                return getRoutes(route.collapse);

            if (route.route) {
                return <Route path={route.path} element={route.component} key={route.key} />;
            }

            return null;
        });
    }

    /*getBgImage = () => {

        if (window.location.pathname.indexOf("/formulario/encuesta") !== -1)
            return encuesta;
        else if (window.location.pathname.indexOf("/formulario/error") !== -1)
            return error;
    };*/
    //
    {/*background="#13789d"*/ }
    return (
        <PageLayout >
            <Helmet>
                <title>Disfruta de los mejores Juegos</title>
            </Helmet>
            <Routes>
                {getRoutes(routes)}
            </Routes>           
            <OthelloCookieConsent />
        </PageLayout>);
}

export default LayoutJuego;